import styled from 'styled-components';

export const OuterIndend = styled.div`
    ${props => {
        if (props.indend) {
            return `margin: ${props.indend}`;
        } else {
            return `margin: 10px 0`;
        }
    }};
`;

export const InnerIndend = styled.div`
    padding: ${({ indend }) => {
        if (indend) {
            return `${indend}px`;
        }

        return '8px';
    }};
`;



// WEBPACK FOOTER //
// ./src/UI/UI/Indends.js